module.exports = __webpack_public_path__ + "img/norway-lung-cancer-female.2f7c056c.png";